import React from "react";
import { Spinner } from "reactstrap";
import Lottie from "lottie-react";
import squareLoadingAnimation from "../../assets/images/square-loader.json";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Loader = (props) => {
  return (
    <React.Fragment>
      <div className="d-flex justify-content-center mx-2 mt-2">
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "50px" }}
        >
          <Lottie
            animationData={squareLoadingAnimation}
            loop={true}
            style={{
              width: 200,
              height: 50,
            }}
          />
        </div>
      </div>
      {toast.error(props.error, {
        position: "top-right",
        hideProgressBar: false,
        progress: undefined,
        toastId: "",
      })}
    </React.Fragment>
  );
};

export default Loader;
